module.exports = __webpack_public_path__ + "static/media/Circle_Light.783073dc.svg";